function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CardTemplate = require('./card.template');
var CardOverlay = /*#__PURE__*/function () {
  function CardOverlay(app, mod) {
    _classCallCheck(this, CardOverlay);
    this.app = app;
    this.mod = mod;
  }

  //obj = {player, card: cardname}
  return _createClass(CardOverlay, [{
    key: "render",
    value: function render() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var player = obj.player;
      var cardname = obj.card;
      var card;
      for (var i = 0; i < this.mod.deck.length; i++) {
        if (this.mod.deck[i].card === cardname) {
          card = this.mod.deck[i];
          break;
        }
      }
      if (!card) {
        console.error('Card not found', cardname);
        return;
      }
      if (!(obj !== null && obj !== void 0 && obj.cardtext)) {
        var cardtext = card.text.toLowerCase();
        if (player == this.mod.game.player) {
          cardtext = 'You' + cardtext.replace('earns', 'earn').replace('moves', 'move').replace('is', 'are');
        } else {
          cardtext = this.mod.game.playerNames[player - 1] + cardtext;
        }
        card.cardtext = cardtext;
      } else {
        card.cardtext = obj.cardtext;
      }

      // Sized by .hud-notice. A generic overlay shrinks to the text because the
      // card is absolutely positioned and scaled out of the layout.
      this.mod.hud.showPopup(CardTemplate(card), 3500);

      // this will clear any ACKNOWLEDGE
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = CardOverlay;